"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _uuid = require("uuid");
var _index = require("./index");
var _Tooltip = _interopRequireDefault(require("../tooltip/Tooltip"));
var _Checkbox = _interopRequireDefault(require("../checkbox/Checkbox"));
var _loader = require("../loader");
var _misc = require("../misc");
var _Icon = _interopRequireDefault(require("../icon/Icon"));
var _Paragraph = _interopRequireDefault(require("../misc/Paragraph"));
var _helpers = require("./helpers");
var _DataTable = _interopRequireDefault(require("./DataTable.style"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var DataTable = function DataTable(props) {
  var checkbox = props.checkbox,
    hideHeader = props.hideHeader,
    orderByField = props.orderByField,
    prefixId = props.prefixId,
    headLabels = props.headLabels,
    genericLabels = props.genericLabels,
    data = props.data,
    isLoading = props.isLoading,
    cellProps = props.cellProps,
    sort = props.sort,
    pagination = props.pagination,
    menuList = props.menuList,
    noResultsMessage = props.noResultsMessage,
    description = props.description,
    search = props.search,
    filter = props.filter,
    striped = props.striped,
    hoverable = props.hoverable,
    bulkAction = props.bulkAction,
    footerActions = props.footerActions,
    disableLastPageArrow = props.disableLastPageArrow,
    dialog = props.dialog,
    hasError = props.hasError,
    withRowActions = props.withRowActions,
    tableHeaderTracking = props.tableHeaderTracking,
    optionsTracking = props.optionsTracking,
    tableFooterTracking = props.tableFooterTracking,
    withFormattedData = props.withFormattedData,
    footer = props.footer;
  var loaderLabel = genericLabels.loaderLabel;
  var tableKeys = Object.keys(headLabels);
  var tableLabels = R.values(headLabels);
  var wrapperProps = {};
  wrapperProps = {
    hasPagination: !!pagination,
    hasError: hasError
  };
  var displayCellValue = function displayCellValue(tableKey, dataItem) {
    return withFormattedData ? (0, _helpers.keyCellFormat)(tableKey, dataItem) : tableKey;
  };
  var list = data.map(function (item) {
    if (!props.checkbox || !R.length(props.checkbox.dirtyChanges)) {
      return item;
    }
    var dirtyChangedItem = R.find(R.propEq('itemId', item.id), props.checkbox.dirtyChanges);
    if (!dirtyChangedItem) {
      return item;
    }
    var dirtyStatus = R.prop('checked', dirtyChangedItem);
    return _objectSpread(_objectSpread({}, item), {}, {
      isChecked: dirtyStatus
    });
  });
  var itemsWithCheckboxEnabled = R.reject(R.prop('isCheckboxDisabled'), list);
  return /*#__PURE__*/_react["default"].createElement(_DataTable["default"], wrapperProps, /*#__PURE__*/_react["default"].createElement("div", {
    className: "data-table-header"
  }, search, bulkAction), /*#__PURE__*/_react["default"].createElement("div", {
    className: "data-table-wrapper"
  }, dialog, filter, /*#__PURE__*/_react["default"].createElement("div", {
    className: "table-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "table-container"
  }, isLoading ? /*#__PURE__*/_react["default"].createElement(_loader.PageLoader, {
    pastDelay: true,
    message: loaderLabel
  }) : /*#__PURE__*/_react["default"].createElement(_index.Table, {
    borderless: true,
    striped: striped,
    hoverable: hoverable,
    className: "table-layout"
  }, !hideHeader && /*#__PURE__*/_react["default"].createElement(_index.TableHead, {
    className: "table-head"
  }, /*#__PURE__*/_react["default"].createElement(_index.TableRow, null, checkbox && /*#__PURE__*/_react["default"].createElement(_index.TableHeadCell, _extends({
    key: (0, _uuid.v4)()
  }, cellProps ? cellProps.checkbox : {}), /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    onChange: function onChange(event, value) {
      props.checkbox.selectAll(value, props.pagination.currentPage);
    },
    checked: R.length(itemsWithCheckboxEnabled) > 0 && (R.all(function (item) {
      return props.checkbox.selectedItems.indexOf(item.id) >= 0;
    })(itemsWithCheckboxEnabled) || R.all(R.prop('isChecked'), itemsWithCheckboxEnabled)),
    disabled: R.all(R.prop('isCheckboxDisabled'), list)
  })), tableLabels.map(function (label, index) {
    var extraProps = cellProps ? cellProps[tableKeys[index]] : null;
    var sortable = !R.isEmpty(extraProps) && !R.isNil(R.prop('sortBy', extraProps)) ? R.prop('sortBy', extraProps) : sort !== null;
    return /*#__PURE__*/_react["default"].createElement(_index.TableHeadCell, _extends({
      sortable: sortable,
      accessor: label,
      clickAction: function clickAction() {
        tableHeaderTracking(tableKeys[index]);
        orderByField(tableKeys[index]);
      },
      id: "".concat(prefixId, "Column").concat(label),
      key: (0, _uuid.v4)(),
      sortDirection: sort && (sort.by === tableKeys[index] ? sort.direction : 'default')
    }, extraProps), label);
  }), (menuList || withRowActions) && /*#__PURE__*/_react["default"].createElement(_index.TableHeadCell, {
    key: (0, _uuid.v4)()
  }))), /*#__PURE__*/_react["default"].createElement(_index.TableBody, {
    className: "table-body"
  }, list.map(function (dataItem, index) {
    var isChecked;
    if (!props.checkbox) {
      isChecked = false;
    } else {
      var _props$checkbox = props.checkbox,
        selectedItems = _props$checkbox.selectedItems,
        dirtyChanges = _props$checkbox.dirtyChanges;
      var isSelected = R.indexOf(dataItem.id, selectedItems) > -1;
      var isDirtyChanged = dirtyChanges ? dirtyChanges.find(function (item) {
        return item.itemId === dataItem.id;
      }) : false;
      isChecked = isSelected || !isDirtyChanged && dataItem.isChecked || isDirtyChanged && isDirtyChanged.checked;
    }
    var isCollapsed = R.prop('collapsed', dataItem);
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
      key: (0, _uuid.v4)()
    }, /*#__PURE__*/_react["default"].createElement(_index.TableRow, {
      key: dataItem.id
    }, checkbox && /*#__PURE__*/_react["default"].createElement(_index.TableCell, _extends({
      key: "".concat(dataItem.id, "Checkbox")
    }, cellProps ? cellProps.checkbox : {}), /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
      id: "".concat(dataItem.id),
      onChange: function onChange(_ref) {
        var target = _ref.target;
        props.checkbox.onChange(dataItem.id, target.checked);
      },
      checked: isChecked,
      disabled: dataItem.isCheckboxDisabled
    })), tableKeys.map(function (key, keyIdx) {
      var extraProps = cellProps ? cellProps[tableKeys[keyIdx]] : null;
      if (dataItem.statusCode) {
        extraProps = _objectSpread(_objectSpread({}, extraProps), {}, {
          statusCode: dataItem.statusCode
        });
      }
      return /*#__PURE__*/_react["default"].createElement(_index.TableCell, _extends({
        key: "".concat(dataItem.id).concat(tableLabels[keyIdx]),
        id: "".concat(prefixId).concat(index).concat(key)
      }, extraProps), description && description.destination === tableKeys[keyIdx] && dataItem.description.length > 0 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
        "data-tip": dataItem[description.source].slice(0, 128)
      }, dataItem[tableKeys[keyIdx]]), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
        id: "".concat(prefixId).concat(index).concat(description.destination, "Tooltip")
      })) : displayCellValue(tableKeys[keyIdx], dataItem));
    }), menuList && !withRowActions && /*#__PURE__*/_react["default"].createElement(_index.TableCell, {
      id: "".concat(prefixId).concat(index, "More"),
      key: "".concat(dataItem.id, "More"),
      align: "right"
    }, /*#__PURE__*/_react["default"].createElement(_misc.MenuList, {
      id: "".concat(prefixId).concat(index, "MoreIcon"),
      menuItems: dataItem.menuTransform ? dataItem.menuTransform(menuList, dataItem) : menuList,
      optionsTracking: optionsTracking,
      itemId: dataItem.id,
      itemsProps: dataItem.menuListProps,
      item: dataItem,
      isActionDisabled: dataItem.isActionDisabled
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: "ion-android-more-vertical",
      size: 18
    }))), withRowActions && /*#__PURE__*/_react["default"].createElement(_index.TableCell, {
      id: "".concat(prefixId).concat(index, "More"),
      key: "".concat(dataItem.id, "More"),
      align: "right"
    }, /*#__PURE__*/_react["default"].createElement(_misc.MenuList, {
      id: "".concat(prefixId).concat(index, "MoreIcon"),
      menuItems: dataItem.rowActions,
      itemId: dataItem.id,
      itemsProps: dataItem.menuListProps,
      item: dataItem,
      isActionDisabled: dataItem.isActionDisabled,
      ignoreSingleItemLogic: true
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: "ion-android-more-vertical",
      size: 18
    })))), isCollapsed && dataItem.versions.map(function (version) {
      return /*#__PURE__*/_react["default"].createElement(_index.TableRow, {
        key: version.id
      }, tableKeys.map(function (key, keyIdx) {
        var extraProps = cellProps ? cellProps[tableKeys[keyIdx]] : null;
        return /*#__PURE__*/_react["default"].createElement(_index.TableCell, _extends({
          key: "".concat(version.id).concat(tableLabels[keyIdx]),
          id: "".concat(prefixId).concat(index).concat(key),
          style: {
            'margin-left': '20px'
          }
        }, extraProps, {
          className: R.prop('className', extraProps) ? "".concat(R.prop('className', extraProps), " table-child-row") : ''
        }), description && description.destination === tableKeys[keyIdx] && version.description.length > 0 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
          "data-tip": version[description.source].slice(0, 128)
        }, version[tableKeys[keyIdx]]), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
          id: "".concat(prefixId).concat(index).concat(description.destination, "Tooltip")
        })) : version[tableKeys[keyIdx]]);
      }), menuList && !withRowActions && /*#__PURE__*/_react["default"].createElement(_index.TableCell, {
        id: "".concat(prefixId).concat(index, "More"),
        key: "".concat(version.id, "More"),
        align: "right"
      }, /*#__PURE__*/_react["default"].createElement(_misc.MenuList, {
        id: "".concat(prefixId).concat(index, "MoreIcon"),
        menuItems: version.menuTransform ? version.menuTransform(menuList, version) : menuList,
        itemId: version.id,
        itemsProps: version.menuListProps,
        item: version,
        isActionDisabled: version.isActionDisabled
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        icon: "ion-android-more-vertical",
        size: 18
      }))), withRowActions && /*#__PURE__*/_react["default"].createElement(_index.TableCell, {
        id: "".concat(prefixId).concat(index, "More"),
        key: "".concat(version.id, "More"),
        align: "right"
      }, /*#__PURE__*/_react["default"].createElement(_misc.MenuList, {
        id: "".concat(prefixId).concat(index, "MoreIcon"),
        menuItems: version.rowActions,
        itemId: version.id,
        itemsProps: version.menuListProps,
        item: version,
        isActionDisabled: version.isActionDisabled,
        ignoreSingleItemLogic: true
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        icon: "ion-android-more-vertical",
        size: 18
      }))));
    }));
  })), footer), !isLoading && list.length === 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "no-results-message"
  }, /*#__PURE__*/_react["default"].createElement(_Paragraph["default"], null, noResultsMessage))), pagination && list.length !== 0 && /*#__PURE__*/_react["default"].createElement(_index.TableFooterPagination, {
    checkbox: checkbox,
    isLoading: isLoading,
    tableFooterTracking: tableFooterTracking,
    pagination: pagination,
    footerActions: footerActions,
    disableLastPageArrow: disableLastPageArrow,
    withFormattedData: withFormattedData
  }))));
};
DataTable.defaultProps = {
  hoverable: true,
  checkbox: null,
  striped: true,
  hideHeader: false,
  orderByField: null,
  isLoading: false,
  sort: null,
  pagination: null,
  cellProps: null,
  menuList: null,
  noResultsMessage: '',
  description: null,
  filter: null,
  search: null,
  genericLabels: {},
  bulkAction: null,
  footerActions: [],
  disableLastPageArrow: true,
  dialog: undefined,
  hasError: false,
  withRowActions: false,
  withFormattedData: false,
  tableHeaderTracking: function tableHeaderTracking() {},
  optionsTracking: function optionsTracking() {},
  tableFooterTracking: {
    tablePaginationFirst: function tablePaginationFirst() {},
    tablePaginationPrev: function tablePaginationPrev() {},
    tablePaginationNext: function tablePaginationNext() {},
    tablePaginationLast: function tablePaginationLast() {}
  },
  footer: null
};
DataTable.propTypes = {
  hoverable: _propTypes["default"].bool,
  checkbox: _propTypes["default"].shape({
    onChange: _propTypes["default"].func.isRequired,
    onClear: _propTypes["default"].func,
    clearLabel: _propTypes["default"].string,
    selectedItems: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].bool, _propTypes["default"].shape({})])).isRequired,
    dirtyChanges: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].bool, _propTypes["default"].shape({})])),
    selectAll: _propTypes["default"].func,
    pagesSelected: _propTypes["default"].shape({})
  }),
  striped: _propTypes["default"].bool,
  orderByField: _propTypes["default"].func,
  prefixId: _propTypes["default"].string.isRequired,
  headLabels: _propTypes["default"].shape({}).isRequired,
  hideHeader: _propTypes["default"].bool,
  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string,
    description: _propTypes["default"].string,
    menuListProps: _propTypes["default"].shape({})
  })).isRequired,
  isLoading: _propTypes["default"].bool,
  cellProps: _propTypes["default"].objectOf(_propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].bool, _propTypes["default"].shape({})]))),
  sort: _propTypes["default"].shape({
    by: _propTypes["default"].string,
    direction: _propTypes["default"].string
  }),
  pagination: _propTypes["default"].shape({
    totalResults: _propTypes["default"].number.isRequired,
    resultsPerPage: _propTypes["default"].number.isRequired,
    currentPage: _propTypes["default"].number.isRequired
  }),
  menuList: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  noResultsMessage: _propTypes["default"].string,
  description: _propTypes["default"].shape({
    destination: _propTypes["default"].string.isRequired,
    source: _propTypes["default"].string.isRequired
  }),
  filter: _propTypes["default"].node,
  search: _propTypes["default"].node,
  genericLabels: _propTypes["default"].objectOf(_propTypes["default"].string),
  bulkAction: _propTypes["default"].node,
  footerActions: _propTypes["default"].arrayOf(_propTypes["default"].node),
  disableLastPageArrow: _propTypes["default"].bool,
  dialog: _propTypes["default"].node,
  hasError: _propTypes["default"].bool,
  withRowActions: _propTypes["default"].bool,
  tableHeaderTracking: _propTypes["default"].func,
  optionsTracking: _propTypes["default"].func,
  tableFooterTracking: _propTypes["default"].shape({
    tablePaginationFirst: _propTypes["default"].func,
    tablePaginationPrev: _propTypes["default"].func,
    tablePaginationNext: _propTypes["default"].func,
    tablePaginationLast: _propTypes["default"].func
  }),
  withFormattedData: _propTypes["default"].bool,
  footer: _propTypes["default"].node
};
DataTable.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DataTable",
  "props": {
    "hoverable": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "checkbox": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "onChange": {
            "name": "func",
            "required": true
          },
          "onClear": {
            "name": "func",
            "required": false
          },
          "clearLabel": {
            "name": "string",
            "required": false
          },
          "selectedItems": {
            "name": "arrayOf",
            "value": {
              "name": "union",
              "value": [{
                "name": "number"
              }, {
                "name": "string"
              }, {
                "name": "bool"
              }, {
                "name": "shape",
                "value": {}
              }]
            },
            "required": true
          },
          "dirtyChanges": {
            "name": "arrayOf",
            "value": {
              "name": "union",
              "value": [{
                "name": "number"
              }, {
                "name": "string"
              }, {
                "name": "bool"
              }, {
                "name": "shape",
                "value": {}
              }]
            },
            "required": false
          },
          "selectAll": {
            "name": "func",
            "required": false
          },
          "pagesSelected": {
            "name": "shape",
            "value": {},
            "required": false
          }
        }
      },
      "required": false
    },
    "striped": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "hideHeader": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "orderByField": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "isLoading": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "sort": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "by": {
            "name": "string",
            "required": false
          },
          "direction": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "pagination": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "totalResults": {
            "name": "number",
            "required": true
          },
          "resultsPerPage": {
            "name": "number",
            "required": true
          },
          "currentPage": {
            "name": "number",
            "required": true
          }
        }
      },
      "required": false
    },
    "cellProps": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "objectOf",
        "value": {
          "name": "objectOf",
          "value": {
            "name": "union",
            "value": [{
              "name": "number"
            }, {
              "name": "string"
            }, {
              "name": "bool"
            }, {
              "name": "shape",
              "value": {}
            }]
          }
        }
      },
      "required": false
    },
    "menuList": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {}
        }
      },
      "required": false
    },
    "noResultsMessage": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "description": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "destination": {
            "name": "string",
            "required": true
          },
          "source": {
            "name": "string",
            "required": true
          }
        }
      },
      "required": false
    },
    "filter": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "search": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "genericLabels": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "objectOf",
        "value": {
          "name": "string"
        }
      },
      "required": false
    },
    "bulkAction": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "footerActions": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "node"
        }
      },
      "required": false
    },
    "disableLastPageArrow": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "dialog": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "hasError": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "withRowActions": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "withFormattedData": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "tableHeaderTracking": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "optionsTracking": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "tableFooterTracking": {
      "defaultValue": {
        "value": "{\r\n  tablePaginationFirst: () => {},\r\n  tablePaginationPrev: () => {},\r\n  tablePaginationNext: () => {},\r\n  tablePaginationLast: () => {},\r\n}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "tablePaginationFirst": {
            "name": "func",
            "required": false
          },
          "tablePaginationPrev": {
            "name": "func",
            "required": false
          },
          "tablePaginationNext": {
            "name": "func",
            "required": false
          },
          "tablePaginationLast": {
            "name": "func",
            "required": false
          }
        }
      },
      "required": false
    },
    "footer": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "prefixId": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "headLabels": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    },
    "data": {
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "id": {
              "name": "string",
              "required": false
            },
            "description": {
              "name": "string",
              "required": false
            },
            "menuListProps": {
              "name": "shape",
              "value": {},
              "required": false
            }
          }
        }
      },
      "required": true
    }
  }
};
var _default = DataTable;
exports["default"] = _default;